import { createContext, useContext } from 'react';

export const ModalPortalContainerContext = createContext<HTMLElement | null>(
    null,
);

export function useModalPortalContainer(): HTMLElement | null {
    return useContext(ModalPortalContainerContext);
}
